import { Injectable } from "@angular/core";
import { Subject } from "rxjs/Subject";
import { PruHttpService } from "./pru-http.service";
import { GenericService } from "./generic.service";
import { AggregationService } from "./aggregation.service";

@Injectable({
  providedIn: "root"
})
export class ExternalAccountsService {
  private extAggSubject: Subject<any> = new Subject();
  public extAgg$ = this.extAggSubject.asObservable();
  constructor(
    private _pruHttpService: PruHttpService,
    private _genericService: GenericService,
    private _aggService: AggregationService
  ) {}

  //getExtAccountsData(indicator?: any): any {
  getExtAccountsData(): any {
    let externalAccountsByCategory = null,
      prodTitles = null;
    this._genericService.spinner = true;
    const aggExtUrl =
      "/api/co/secure/myaccounts/v2/accountsummary?buName=AGG&clearcache=" +
      this._genericService.xPruId;
    // if (/localhost/i.test(helpers.getCurrentHost())) aggExtUrl = '/aggData1';
    this._pruHttpService.get(aggExtUrl, "AggregatedService").subscribe(
      (res: any) => {
        if (
          res &&
          res.contractSummaryResponse &&
          res.contractSummaryResponse.contractSummary
        ) {
          if (res.contractSummaryResponse.contractSummary.length > 0) {
            prodTitles = [
              "bank",
              "investments",
              "insurance",
              "debt",
              "other",
              "focusArr"
            ];
            externalAccountsByCategory = {}; //{'Cash':[], 'Investments':[], 'Insurance':[], 'Debt':[], 'Other':[]};
            prodTitles.forEach((element, index) => {
              externalAccountsByCategory[prodTitles[index]] = [];
            });

            res.contractSummaryResponse.contractSummary.forEach(element => {
              externalAccountsByCategory.focusArr.push(
                element.providerAccountID + element.contractID
              );
              element.productTitle = element.productTitle
                ? element.productTitle
                : "N/A";
              element.lineOfBusiness = element.lineOfBusiness
                ? element.lineOfBusiness
                : element.productTitle;
              element.accountType = "external account";
              if (
                element &&
                (element.productCategory.toLowerCase() === "cash" ||
                  element.productCategory.toLowerCase() === "bank")
              ) {
                externalAccountsByCategory.bank.push(element);
              } else if (
                element &&
                element.productCategory.toLowerCase() === "investment"
              ) {
                externalAccountsByCategory.investments.push(element);
              } else if (
                element &&
                element.productCategory.toLowerCase() === "insurance"
              ) {
                externalAccountsByCategory.insurance.push(element);
              } else if (
                element &&
                (element.productCategory.toLowerCase() === "creditcard" ||
                  element.productCategory.toLowerCase() === "loan")
              ) {
                externalAccountsByCategory.debt.push(element);
              } else if (element) {
                externalAccountsByCategory.other.push(element);
              }
            });
            this._genericService.addAggData(res["contractSummaryResponse"]);
            this.extAggSubject.next(externalAccountsByCategory);
          } else {
            externalAccountsByCategory = [];
            this.handleErrorExtAccountsData("empty");
          }
        } else {
          externalAccountsByCategory = null;
          this.handleErrorExtAccountsData("error");
        }
      },
      error => {
        externalAccountsByCategory = null;
        this.handleErrorExtAccountsData("error");
      }
    );
  }

  private handleErrorExtAccountsData(eve_type) {
    this._genericService.addAggData({
      contractSummary: [],
      responseCode: "200"
    });
    this.extAggSubject.next(eve_type);
  }
}
